exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#tothetop-wrapper[data-v-7ce7bb08]{position:fixed;bottom:20px;right:35px;padding:10px;border-radius:50%;background-color:#fff;box-shadow:0 0 3px #d6d6d6}", ""]);

// exports
